import { KEYS_FIELD_LIST, RIGHT_FIELDS } from '../constants'
import { InputUserProfile } from './InputUserProfile'

export const RightFields = ({ form, isValid, onChange }) => {
  return (
    <>
      {RIGHT_FIELDS.slice(0, 5).map((item) => (
        <div key={item.key}>
          <InputUserProfile
            title={item.title}
            containerStyle={{
              height: 28,
            }}
            value={form[item.key]}
            disabled={item.isDisable}
            isValid={isValid[item.key]}
            textInvalid={'userProfile.REQUIRED_FIELD'}
            onChange={(e) => onChange(item.key, e, item.isRequired)}
            inputKey={item.key}
          />
        </div>
      ))}

      <InputUserProfile
        title={'userProfile.CONTACT_EMAIL'}
        containerStyle={{
          height: 28,
        }}
        value={form[KEYS_FIELD_LIST.CONTACT_EMAIL]}
        isValid={isValid[KEYS_FIELD_LIST.CONTACT_EMAIL]}
        textInvalid={
          typeof form[KEYS_FIELD_LIST.CONTACT_EMAIL] === 'string' &&
          !!form[KEYS_FIELD_LIST.CONTACT_EMAIL].trim()
            ? 'domesticSearchPreview.INVALID_EMAIL'
            : 'userProfile.REQUIRED_FIELD'
        }
        onChange={(e) => onChange(KEYS_FIELD_LIST.CONTACT_EMAIL, e, true)}
        inputKey={KEYS_FIELD_LIST.CONTACT_EMAIL}
      />

      <InputUserProfile
        title={'userProfile.COMPANY_PHONE'}
        containerStyle={{
          height: 28,
        }}
        value={form[KEYS_FIELD_LIST.COMPANY_PHONE]}
        isValid={isValid[KEYS_FIELD_LIST.COMPANY_PHONE]}
        textInvalid={
          typeof form[KEYS_FIELD_LIST.COMPANY_PHONE] === 'string' &&
          !!form[KEYS_FIELD_LIST.COMPANY_PHONE].trim()
            ? 'domesticSearchPreview.INVALID_PHONE'
            : 'userProfile.REQUIRED_FIELD'
        }
        onChange={(e) => onChange(KEYS_FIELD_LIST.COMPANY_PHONE, e, true)}
        inputKey={KEYS_FIELD_LIST.COMPANY_PHONE}
      />

      <InputUserProfile
        title={'userProfile.ADDRESS'}
        containerStyle={{
          height: 28,
        }}
        value={form[KEYS_FIELD_LIST.ADDRESS]}
        isValid={isValid[KEYS_FIELD_LIST.ADDRESS]}
        onChange={(e) => onChange(KEYS_FIELD_LIST.ADDRESS, e, false)}
        inputKey={KEYS_FIELD_LIST.ADDRESS}
      />
    </>
  )
}
